import { sdk } from "@/lib/medusa/client";
import { toast } from "@/components/atoms/toast";
import { __ } from "@/lib/i18n/functions";
import { FetchError } from "@medusajs/js-sdk";
import type { Locales } from "@/lib/i18n";

type FileType = {
  idFile?: number;
  closed?: number;
  inProgress?: number;
  invoices?: Array<{
    nNumber?: number;
  }>;
};

export const downloadInvoiceHandler = async (orderId: string, locale: Locales) => {
  try {
    // Get vary order ( file ) :
    const res = await sdk.client.fetch<FileType>(`store/middleware/order/${orderId}/files`);
    const invoiceNumber = res.invoices?.[0]?.nNumber;

    if (!invoiceNumber) {
      toast.error({ title: __("No invoice found for this order.", locale) });
      return;
    }

    // Get Invoice PDF :
    const backendUrl = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL;
    const invoiceUrl = `${backendUrl}/store/middleware/invoice/${invoiceNumber}`;

    const response = await fetch(invoiceUrl, {
      method: "GET",
      headers: {
        Accept: "application/pdf",
        "x-publishable-api-key": process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY || "",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Invoice fetch failed: ${errorText}`);
    }

    // Download PDF
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${__("INVOICE", locale).toLocaleLowerCase()}_${orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    if (err instanceof FetchError && err.message.includes("basket is not converted to files yet")) {
      toast.warning({
        title: __(
          "Festi team is processing your order. An invoice would be available after your order has been processed.",
          locale
        ),
      });
      return;
    }

    toast.error({ title: __("Something went wrong, Please try again later.", locale) });
    console.info("FROM INVOICE HANDLER : FAILED TO GET FILE : ", err);
  }
};
